import React from 'react';
import { AvatarGroup } from '@mui/material';
import "./JoinTripCard.css"
import ClickableAvatar from './ClickableAvatar';

const JoinTripCard = ({ title, subtitle, participants, image, description, onClick }) => {
    const size = participants.length;
    // const finalTitle = subtitle === "" ? title : `${title}, ${subtitle}`
    return (
        <>
            <div className="join-preview" dir="rtl" style={{ cursor: 'pointer' }} onClick={onClick}>
                <div className="image-container">
                    <img src={image} alt={title} className="join-preview-img" />
                    <AvatarGroup className={"join-participants " + (size === 2 ? "two" : (size === 3 ? "three" : (size === 1 ? "single" : "high"))) + "-participants"} spacing={"small"} max={3}>
                        {
                            participants.map((p) => {
                                return <ClickableAvatar
                                    id={p}
                                    sx={{ height: "4em", width: "4em" }}
                                />
                            })
                        }
                    </AvatarGroup>
                </div>

                <div className="join-preview-content">
                    <h3 className="join-title">{title}</h3>
                    {subtitle && (
                        <div className="join-subtitle">
                            {subtitle}
                        </div>
                    )}

                    <div className="join-details">
                        {description}
                    </div>
                </div>

                {/*<div className="trip-participants">*/}
                {/*</div>*/}
            </div>
        </>
    );
};

export default JoinTripCard;
